// generated by genversion
export const version = '2.6.0'
